export default {
    latest_ad_account(state) {
        return state.ad_accounts[0];
    },
    latest_campaign(state) {
        return state.facebook_campaigns[0];
    },
}